export default "__VITE_ASSET__Bx1DTdUd__"